"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectedProductVerificationLevelConfig = exports.decimalsByProductId = exports.baseNotionalProductSymbolSelector = exports.baseNotionalProductSelector = exports.baseCurrencyDecimalsPlacesSelector = void 0;
var _reselect = require("reselect");
var decimalsByProductId = exports.decimalsByProductId = (0, _reselect.createSelector)(function (state) {
  return state.apexCore.product.products;
}, function (products) {
  return products.reduce(function (decimalPlaces, product) {
    decimalPlaces[product.ProductId] = product.DecimalPlaces;
    return decimalPlaces;
  }, {});
});
var selectedProductVerificationLevelConfig = exports.selectedProductVerificationLevelConfig = (0, _reselect.createSelector)([function (state) {
  return state.user.verificationLevelConfigs;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}], function (configs, selectedProductId) {
  return configs.Products.find(function (_ref) {
    var ProductId = _ref.ProductId;
    return ProductId === selectedProductId;
  });
});
var baseNotionalProductSymbolSelector = exports.baseNotionalProductSymbolSelector = (0, _reselect.createSelector)(function (state) {
  return state.apexCore.baseNotionalProduct;
}, function (baseNotionalProductInfo) {
  return (baseNotionalProductInfo === null || baseNotionalProductInfo === void 0 ? void 0 : baseNotionalProductInfo.BaseNotionalProductSymbol) || 'USD';
});
var baseNotionalProductSelector = exports.baseNotionalProductSelector = (0, _reselect.createSelector)(baseNotionalProductSymbolSelector, function (state) {
  return state.apexCore.product.products;
}, function (baseNotionalProductSymbol, products) {
  return products.find(function (_ref2) {
    var Product = _ref2.Product;
    return Product === baseNotionalProductSymbol;
  }) || {
    Product: 'USD',
    DecimalPlaces: 2
  };
});
var baseCurrencyDecimalsPlacesSelector = exports.baseCurrencyDecimalsPlacesSelector = (0, _reselect.createSelector)(baseNotionalProductSymbolSelector, function (state) {
  return state.product.products;
}, function (baseCurrency, products) {
  var _products$find;
  return (_products$find = products.find(function (product) {
    return product.Product === baseCurrency;
  })) === null || _products$find === void 0 ? void 0 : _products$find.DecimalPlaces;
});